import type { BlueprintUnderlay } from '@shared/models/design/blueprint-underlay.model';

export const AUTOMATIC_SCALE_SET_MESSAGE = 'Automatic scale set';
export const AUTOMATIC_SCALE_ADJUST_LABEL = 'Adjust';

export type BlueprintPostImportAction =
  { kind: 'startCalibrate' } | { kind: 'inheritedScale' };

/**
 * After placing imported pages: measure when none have a scale, otherwise
 * inherit and toast. Looks at the placed sheets, not the PDF page count.
 */
export const resolveBlueprintPostImportAction = (
  underlays: readonly BlueprintUnderlay[],
): BlueprintPostImportAction => {
  const hasScale = underlays.some((underlay) =>
    Boolean(underlay.calibration?.primary),
  );
  return hasScale ? { kind: 'inheritedScale' } : { kind: 'startCalibrate' };
};
